// extracted by mini-css-extract-plugin
export default {"confirmModal":"index_confirmModal__nC594"};